import React from 'react';
import { Skeleton } from '@mui/material';

interface LazyImageProps {
  src: string;
  alt: string;
  width?: string | number;
  height?: string | number;
  style?: React.CSSProperties;
  className?: string;
}

const LazyImage: React.FC<LazyImageProps> = ({ src, alt, width, height, style, className }) => {
  const [isLoaded, setIsLoaded] = React.useState(false);
  const [isError, setIsError] = React.useState(false);

  return (
    <div style={{ width, height, position: 'relative' }}>
      {!isLoaded && !isError && (
        <Skeleton variant="rectangular" width="100%" height="100%" animation="wave" />
      )}
      <img
        src={src}
        alt={alt}
        style={{
          ...style,
          width: '100%',
          height: '100%',
          objectFit: 'contain',
          opacity: isLoaded ? 1 : 0,
          transition: 'opacity 0.3s ease-in-out',
          display: isError ? 'none' : 'block'
        }}
        className={className}
        onLoad={() => setIsLoaded(true)}
        onError={() => setIsError(true)}
        loading="lazy"
      />
    </div>
  );
};

export default LazyImage; 